<template>
  <div>
    <curvas-popularidade-tabela class="mx-2" />
  </div>
</template>

<script>
import CurvasPopularidadeTabela from "./CurvasPopularidadeTabela";
export default {
  name: "Index",
  components: {CurvasPopularidadeTabela}
}
</script>

<style scoped>

</style>
